import {ExpandMore} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Grid, TextField} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {useTranslation} from "react-i18next";
const VehicleDetails = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const [isExpanded, setIsExpanded] = useState(true);
    const vehicle = props.vehicle;
    return (
        <Accordion defaultExpanded onChange={(_e, expanded) => {
            setIsExpanded(expanded);
        }}>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Grid item md={6} xs={6}>
                    {t("customerRADetails.vehicleDetails")}
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled={true}
                            InputLabelProps={{shrink: true}}
                            value={vehicle?.plate ? vehicle.plate : ""}
                            label={t("vehicleDetails.licensePlate")}
                            type="text"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            InputLabelProps={{shrink: true}}
                            fullWidth
                            disabled={true}
                            value={vehicle?.vin}
                            label={t("vehicleDetails.chassis")}
                            type="text"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            InputLabelProps={{shrink: true}}
                            fullWidth
                            disabled={true}
                            value={vehicle?.model && vehicle?.model?.brand ? vehicle.model.brand.descr : ""}
                            label={t("vehicleDetails.brand")}
                            type="text"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            InputLabelProps={{shrink: true}}
                            fullWidth
                            disabled={true}
                            value={vehicle?.model && vehicle?.model?.brand ? vehicle.model.descr : ""}
                            label={t("vehicleDetails.model")}
                            type="text"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            InputLabelProps={{shrink: true}}
                            fullWidth
                            disabled={true}
                            value={vehicle?.colorExt}
                            label={t("vehicleDetails.color")}
                            type="text"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            InputLabelProps={{shrink: true}}
                            fullWidth
                            disabled={true}
                            value={vehicle?.color}
                            id="property"
                            label={t("vehicleDetails.property")}
                            type="text"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            InputLabelProps={{shrink: true}}
                            fullWidth
                            disabled={true}
                            value={vehicle?.acriss ? vehicle.acriss.code : ""}
                            id="carGroup"
                            label={t("vehicleDetails.carGroup")}
                            type="text"
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default VehicleDetails;